<template>
  <aside class="vertical-nav">
    <section class="h-100 row region region-vertical-menu">
      <nav role="navigation" aria-labelledby="block-mainnavigation-menu" id="block-mainnavigation"
           class="col-md-12 contextual-region block block-menu navigation menu--main">
        <ul class="h-100 clearfix nav navbar-nav">
          <template v-if="mode==='user'">
            <router-link tag="li" to="/" class="nav-item" active-class="active" exact>
              <a class="nav-link dashboard nav-link--dashboard">
                {{ $t('message.dashboard') }}
              </a>
            </router-link>
            <router-link tag="li" to="/evolution" class="nav-item" active-class="active">
              <a class="nav-link evolution">
                {{ $t('message.evolution') }}
              </a>
            </router-link>
            <router-link tag="li" to="/vitamins" class="nav-item" active-class="active">
              <a class="nav-link vitamins">
                {{ $t('message.vitamins') }}
              </a>
            </router-link>
          </template>
          <template v-else-if="mode === 'manager'">
            <router-link tag="li" to="/dashboard-manage" class="nav-item" active-class="active">
              <a class="nav-link dashboard nav-link--dashboard">
                {{ $t('message.dashboard') }}
              </a>
            </router-link>
            <router-link tag="li" to="/userlist" class="nav-item" active-class="active">
              <a class="nav-link userlist">
                {{ $t('message.user_list') }}
              </a>
            </router-link>

          </template>
          <template v-else-if="mode === 'hr'">
            <router-link tag="li" to="/dashboard-hr" class="nav-item" active-class="active">
              <a class="nav-link dashboard nav-link--dashboard">
                {{ $t('message.dashboard') }}
              </a>
            </router-link>
            <router-link tag="li" to="/userlist" class="nav-item" active-class="active">
              <a class="nav-link userlist">
                {{ $t('message.user_list') }}
              </a>
            </router-link>
            <router-link tag="li" to="/teams" class="nav-item" active-class="active">
              <a class="nav-link teamlist d-block">
                <i class="fa-2x fal fa-users-class"></i>
                <span class="d-block m-0 mt-2">{{ $t('message.teams') }}</span>
              </a>
            </router-link>
          </template>
          <li class="mt-auto nav-item" @click.prevent.stop="store.dispatch('signout')">
            <a href="#" class="nav-link logout">
              {{ $t('message.sign_out') }}
            </a>
          </li>
        </ul>
      </nav>
    </section>
  </aside>
</template>


<script>
  import store from "../store/store";

  export default {
    data() {
      return {
        store,
        // mode: store.state.viewMode
      }
    },
    computed: {
      mode() {
        return store.state.viewMode
      }
    }
  }
</script>


<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Nav.vue